import React from 'react';
import './title.scss';

export default function Title({ children, centered }) {
  return <h2 className={`h2-title ${centered ? 'centered' : ''}`}>{children}</h2>;
}
